import { Stack, Text, useMantineTheme } from '@mantine/core'
import { IconBrandDiscord } from '@tabler/icons-react'
import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import RootButton from '@/components/Buttons/RootButton'
import { CandidateStatus } from '@/hooks/useGovernance'

interface CampaignActionProps {
  nominee: string
  status: CandidateStatus
  campaignLinks: Map<string, string>
  loadingCampaignLinks: boolean
  isBreakpoint: boolean
}

const CampaignAction: React.FC<CampaignActionProps> = ({
  nominee,
  status,
  campaignLinks,
  loadingCampaignLinks,
  isBreakpoint,
}) => {
  const { t } = useTranslation()
  const theme = useMantineTheme()

  const nomineeLink = useMemo(() => {
    if (campaignLinks.has(nominee)) {
      return campaignLinks.get(nominee) || ''
    }
    return ''
  }, [campaignLinks, nominee])

  const handleDiscordRedirect = useCallback(() => {
    if (!nomineeLink) return
    window.open(nomineeLink, '_blank')
  }, [nomineeLink])

  return (
    <Stack style={{ flexDirection: 'row', justifyContent: isBreakpoint ? 'center' : 'flex-end' }}>
      {status === 'REMOVED' ? (
        <Text>Candidate Removed by Foundation</Text>
      ) : (
        <RootButton
          expand={isBreakpoint}
          onClick={handleDiscordRedirect}
          style1={false}
          leftSection={<IconBrandDiscord size="22px" color={theme.colors.background[0]} />}
          loading={loadingCampaignLinks}
          disabled={!nomineeLink}
        >
          {t('components.elections.campaignAction.viewCampaign', 'View Campaign')}
        </RootButton>
      )}
    </Stack>
  )
}

export default CampaignAction
